import React from 'react';
import CampaignsTable from './components/CampaignsTable/CampaignsTable';

const Campaigns = () => {
  return <CampaignsTable />;
};

export default Campaigns;
